import { Injectable } from '@angular/core';
import { SweetAlertOptions } from 'sweetalert2';


@Injectable()
export class TemplateModalService {
  private sweetAlertOptions: SweetAlertOptions;

  constructor() {
  }

  public getSuccessAlertOptions(successTitle: string, message: string, recordType: string) {
    return this.sweetAlertOptions = {
      title: successTitle,
      icon: 'success',
      buttonsStyling: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: `View ${recordType}`,
      customClass: { confirmButton: 'btn btn-secondary me-3' },
      html: this.getSuccessTemplate(message)
    };
  }

  public getConfirmAlertOptions(title: string, subTitle: string, message: string, recordType: string) {
    return this.sweetAlertOptions = {
      title: title,
      buttonsStyling: false,
      showCloseButton: true,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: `Confirm`,
      cancelButtonText: 'Cancel',
      customClass: { confirmButton: 'btn btn-success me-3', cancelButton: 'btn btn-warning me-3' },
      html: this.getDeleteTemplate(subTitle, message, recordType)
    };
  }

  public getInactivityOptions(title: string, message: string) {
    return this.sweetAlertOptions = {
      title: title,
      buttonsStyling: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Ok',
      customClass: { confirmButton: 'btn btn-secondary me-3' },
      html: this.getInactivityTemplate(message)
    };
  }

  public getDeleteTemplate(message: string, record: string, recordName: string) {
    return `
      <div class="body">
         <h2>${message}</h2>
         <div class="details">
           <p><b>${record}:</b>${recordName}</p>
         </div>
      </div>`;
  }

  public getConfirmTemplate(message: string, record: string, recordName: string) {
    return `
      <div class="body">
         <h2>${message}</h2>
         <div class="details">
           <p><b>${record}:</b>${recordName}</p>
         </div>
      </div>`;
  }

  public getSuccessTemplate(message: string) {
    return `
      <div class="body success">
        <p><strong>Success!</strong></p>
        <div class="details">
          <p>${message}</p>
        </div>
      </div>`;
  }

  public getInactivityTemplate(message: string) {
    return `
      <div class="body">
        <div class="details">
          <p><i class="fa fa-clock-o" aria-hidden="true"></i> ${message}</p>
        </div>
      </div>`;
  }

}
